var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParenthesesAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5ZM8.98093 5.3508C9.33948 5.5582 9.462 6.017 9.25459 6.37554C8.29783 8.02951 7.75 9.94964 7.75 12C7.75 14.0504 8.29783 15.9705 9.25459 17.6245C9.462 17.983 9.33948 18.4418 8.98093 18.6492C8.62239 18.8566 8.16359 18.7341 7.95618 18.3755C6.87091 16.4994 6.25 14.3211 6.25 12C6.25 9.67892 6.87091 7.50058 7.95618 5.62446C8.16359 5.26591 8.62239 5.14339 8.98093 5.3508ZM14.7454 6.37554C14.538 6.017 14.6605 5.5582 15.0191 5.3508C15.3776 5.14339 15.8364 5.26591 16.0438 5.62446C17.1291 7.50058 17.75 9.67892 17.75 12C17.75 14.3211 17.1291 16.4994 16.0438 18.3755C15.8364 18.7341 15.3776 18.8566 15.0191 18.6492C14.6605 18.4418 14.538 17.983 14.7454 17.6245C15.7022 15.9705 16.25 14.0504 16.25 12C16.25 9.94964 15.7022 8.02951 14.7454 6.37554Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParenthesesAlt2);
export default __webpack_public_path__ + "static/media/parentheses-alt-2.9eaf69513ab8dc1317977207f1ac2f9a.svg";
export { ForwardRef as ReactComponent };